export default "__VITE_ASSET__499513c3__"